module.exports = __webpack_public_path__ + "img/logo_oneboxbusiness-horizontal.a8135e1d.png";